import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ApprovalStatuses, DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFile from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentListForProject, getDownloadableLink, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { AttachFile } from "@mui/icons-material";
import { middleTruncate } from "../../helpers/string_helper";
import { ClearIcon } from "@mui/x-date-pickers";
import DoneIcon from "@mui/icons-material/Done";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const SubmitLegalDocument = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  t,
  source = '',
  handleStatusChange,
  rowId,
  actionType,
  projectIdForApproval,
  moduleIdforApproval,
  fetchDeliverableDetails,
  status
}) => {
  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [crnNameFiles, setCrnNameFiles] = useState({});
  const [crnNumberFiles, setCrnNumberFiles] = useState({});
  const [iBanNumberFiles, setIBanNumberFiles] = useState({});
  const [establishmentContractFiles, setEstablishmentContractFiles] = useState({});
  const [agreementDocFiles, setAgreementDocFiles] = useState({});
  // const [rcFiles, setRcFiles] = useState({});
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [crnNameLoading, setCrnNameLoading] = useState(false);
  const [crnNumberLoading, setCrnNumberLoading] = useState(false);
  const [iBanNumberLoading, setIBanNumberLoading] = useState(false);
  const [establishmentContractLoading, setEstablishmentContractLoading] = useState(false);
  const [agreementDocFileLoading, setAgreementDocFileLoading] = useState(false);
  // const [rcLFileLoading, setRcFileLoading] = useState(false);
  const [deletingFileType, setDeletingFileType] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [approvedButtonLoading, setApprovedButtonLoading] = useState(false);
  const [rejectButtonLoading, setRejectButtonLoading] = useState(false);
  const deliverableValidation = Yup.object().shape({
    // description: Yup.string()
    //   .max(2000, t("Description can not be greater than 2000 characters"))
    //   .strict(true)
    //   .trim(t('Must not include leading and trailing spaces'))
    //   .required(t("Please enter Description")),
    crnName: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter CR name")),
    crnNumber: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter CR number")),
    bankName: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter Bank Name")),
    iBanNumber: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter IBAN Number")),
    crnNameAttachmentId: Yup.number().required(t('Select CR Name document')),
    crnNumAttachmentId: Yup.number().required(t('Select CR Number document')),
    iBanNumAttachmentId: Yup.number().required(t('Select iBanNumber document')),
    establishmentContractAttachmentId: Yup.number().required(t('Select Article of Association')),
    agreementDocFileId: Yup.number().nullable(),
    // rcFileId: Yup.number().required(t('Select Acknowledgement of the RC document')),
  })

  const formik = useFormik({
    initialValues: {
      name: selectedRow?.deliverable.name ?? "",
      // startDate: selectedRow?.deliverable.startDate ?? "",
      // endDate: selectedRow?.deliverable.endDate ?? "",
      startDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate?.toString().trim()
                  ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate)
                  : dayjs(selectedRow?.deliverable?.StartDate),
      endDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate?.toString().trim()
                ? dayjs(selectedRow?.deliverable.PortfolioDeliverable[0]?.endDate)
                : dayjs(selectedRow?.deliverable?.endDate),
      description: selectedRow?.description ?? "",
      crnName: selectedRow?.crnName ?? "",
      crnNumber: selectedRow?.crnNumber ?? "",
      bankName: selectedRow?.bankName ?? "",
      iBanNumber: selectedRow?.iBanNumber ?? "",
      crnNameAttachmentId: "",
      crnNumAttachmentId: "",
      iBanNumAttachmentId: "",
      establishmentContractAttachmentId: "",
      agreementDocFileId: "",
      // rcFileId: "",
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    // validateOnChange: true,
    // validateOnBlur: true
  });

  useEffect(() => {
    if (selectedRow && action !== Action.EDIT) {
      getDocumentList()
      if (
        ![DeliverableStatus.DRAFT, ProjectDeliverableStatus.REJECTED, ProjectDeliverableStatus.DELAYED].includes(
          selectedRow.currentStatus
        ) ||
        isDisabled || action === Action.VIEW || action === Action.APPROVE
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  const fileFieldKeys = [
    "crnNameAttachmentId",
    "crnNumAttachmentId",
    "iBanNumAttachmentId",
    "establishmentContractAttachmentId",
    "agreementDocFileId",
    // "rcFileId"
  ];

  useEffect(() => {
    fileFieldKeys.forEach((field) => {
      const value = formik.values[field];
      if (value) {
        formik.validateField(field);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, fileFieldKeys.map((key) => formik.values[key]));

  const handleFileUpload = async (key, file) => {
    const loaders = {
      'CRN Name': setCrnNameLoading,
      'CRN Number': setCrnNumberLoading,
      'IBAN Certificate': setIBanNumberLoading,
      'Establishmnent Contract': setEstablishmentContractLoading,
      'Agreement Document': setAgreementDocFileLoading,
      // 'Acknowledgement of the RC': setRcFileLoading
    };

    const formikFields = {
      'CRN Name': 'crnNameAttachmentId',
      'CRN Number': 'crnNumAttachmentId',
      'IBAN Certificate': 'iBanNumAttachmentId',
      'Establishmnent Contract': 'establishmentContractAttachmentId',
      'Agreement Document': 'agreementDocFileId',
      // 'Acknowledgement of the RC': 'rcFileId'
    };

    try {
      const fileExtension = file ? `.${file.name.split('.').pop().toLowerCase()}` : '';
      if (file && !AcceptFileType.includes(fileExtension)) {
        toast.error('Invalid file type');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        toast.error('Please upload file size less than 10 MB');
        return;
      }

      const setLoader = loaders[key];
      setLoader(true);

      const formData = new FormData();
      formData.append('files', file);
      formData.append('moduleId', selectedRow.id);
      formData.append('module', DocumentModule.PROJECT_DELIVERABLE);
      formData.append('projectId', selectedRow.projectId);
      formData.append('documentType', key);

      const result = (await uploadFile(formData)).data.data;

      // Update specific file array and formik attachment ID
      formik.setFieldValue(formikFields[key], result.id);
      formik.setFieldTouched(formikFields[key], true); // Mark as touched to trigger validation
      await formik.validateForm(); // Validate entire form

      setTrigger(new Date());
      getDocumentList();
      setLoader(false);
    } catch (error) {
      const setLoader = loaders[key];
      setLoader(false);
      toast.error(error.message || 'Error uploading file');
    }
  };

  const handleLinkDownload = async (documentId) => {
    try {
      const result = await getDownloadableLink(documentId);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
        window.open(result.data.data, '_blank');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const getDocumentList = async () => {
    try {
      setCrnNameLoading(true)
      setCrnNumberLoading(true)
      setIBanNumberLoading(true)
      setEstablishmentContractLoading(true)
      setAgreementDocFileLoading(true)
      // setRcFileLoading(true)
      let params = {
        projectId: source === 'ActionList' ? selectedRow.project.id : selectedRow.projectId,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.PROJECT_DELIVERABLE,
        moduleId: source = selectedRow.id
      };
      const documentData = await documentListForProject(params)
      const documentDataList = documentData.data.data

      // First set all file states
      documentDataList.forEach(dl => {
        if (dl.documentType.name === 'CRN Name') {
          setCrnNameFiles(dl)
          formik.setFieldValue('crnNameAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'CRN Number') {
          setCrnNumberFiles(dl)
          formik.setFieldValue('crnNumAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'IBAN Certificate') {
          setIBanNumberFiles(dl)
          formik.setFieldValue('iBanNumAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'Establishmnent Contract') {
          setEstablishmentContractFiles(dl)
          formik.setFieldValue('establishmentContractAttachmentId', dl.id)
        }
        if (dl.documentType.name === 'Agreement Document') {
          setAgreementDocFiles(dl)
          formik.setFieldValue('agreementDocFileId', dl.id)
        }
        // if (dl.documentType.name === 'Acknowledgement of the RC') {
        //   setRcFiles(dl)
        //   formik.setFieldValue('rcFileId', dl.id)
        // }
      });

      setCrnNameLoading(false)
      setCrnNumberLoading(false)
      setIBanNumberLoading(false)
      setEstablishmentContractLoading(false)
      setAgreementDocFileLoading(false)
      // setRcFileLoading(false)

    } catch (err) {
      console.log(err)
      setCrnNameLoading(false)
      setCrnNumberLoading(false)
      setIBanNumberLoading(false)
      setEstablishmentContractLoading(false)
      setAgreementDocFileLoading(false)
      // setRcFileLoading(false)
    }
  }

  const handelDeleteAttachment = async () => {
    const loaderMap = {
      'CRN Name': setCrnNameLoading,
      'CRN Number': setCrnNumberLoading,
      'IBAN Certificate': setIBanNumberLoading,
      'Establishmnent Contract': setEstablishmentContractLoading,
      'Agreement Document': setAgreementDocFileLoading,
      // 'Acknowledgement of the RC': setRcFileLoading

    };

    const fileStateMap = {
      'CRN Name': {
        setFiles: setCrnNameFiles,
        fieldKey: 'crnNameAttachmentId',
        files: crnNameFiles,
      },
      'CRN Number': {
        setFiles: setCrnNumberFiles,
        fieldKey: 'crnNumAttachmentId',
        files: crnNumberFiles,
      },
      'IBAN Certificate': {
        setFiles: setIBanNumberFiles,
        fieldKey: 'iBanNumAttachmentId',
        files: iBanNumberFiles,
      },
      'Establishmnent Contract': {
        setFiles: setEstablishmentContractFiles,
        fieldKey: 'establishmentContractAttachmentId',
        files: establishmentContractFiles,
      },
      'Agreement Document': {
        setFiles: setAgreementDocFiles,
        fieldKey: 'agreementDocFileId',
        files: agreementDocFiles,
      },
      // 'Acknowledgement of the RC': {
      //   setFiles: setRcFiles,
      //   fieldKey: 'rcFileId',
      //   files: rcFiles,
      // },
    };

    try {
      setIsOpenSweetAlert(false);
      const loaderSetter = loaderMap[deletingFileType];
      loaderSetter?.(true);

      const res = await deleteDocument(documentId);
      toast.success(res.data.message);

      const fileSet = fileStateMap[deletingFileType];
      fileSet.setFiles({}); // Clear the file state
      formik.setFieldValue(fileSet.fieldKey, ""); // Clear the formik field value
      formik.setFieldTouched(fileSet.fieldKey, true); // Mark field as touched to trigger validation
      await formik.validateForm(); // Validate entire form

      setDocumentId();
      setDeletingFileType('');
      loaderSetter?.(false);
    } catch (err) {
      const loaderSetter = loaderMap[deletingFileType];
      loaderSetter?.(false);

      setDocumentId();
      setDeletingFileType('');
      toast.error(err.message);
    }
  };

  const deliverableSubmit = async () => {
    try {
      const isValid = await formik.validateForm();
      if (Object.keys(isValid).length !== 0 && selectedRow.currentStatus === ProjectDeliverableStatus.REJECTED ? !formik.values?.description : false) {
        formik.setTouched({
          crnName: true,
          crnNumber: true,
          bankName: true,
          iBanNumber: true,
          crnNameAttachmentId: true,
          crnNumAttachmentId: true,
          iBanNumAttachmentId: true,
          establishmentContractAttachmentId: true,
          agreementDocFileId: true,
          // rcFileId: true
        });
        return toast.error("Please fix the validation errors.");
      }
      setIsLoading(true);

      const { agreementDocFileId, ...restValues } = formik.values;

      const payload = {
        ...restValues,
        status: ProjectDeliverableStatus.APPROVED,
        projectId: parseInt(selectedRow.projectId),
        deliverableId: parseInt(selectedRow.deliverable.id),
        ...(agreementDocFileId !== '' && { agreementDocFileId })
      };

      const res = await updateDeliverableStatus(payload);

      if (res.statusCode === 200) {
        toast.success(res.data.message);
        refresh();
      } else {
        toast.error(res.message);
      }

      handleClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        className="projectListDrawer"
        PaperProps={{
          sx: { width: "580px" },
        }}
      >
        <form className="editMilestoneDrawer p-3">
          <h5>{t("Deliverable")}</h5>
          <CloseIcon className="crossIcon" onClick={handleClose} />
          <div className="innerTbContent">
            <div className="row">
              {/* Name */}
              <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={t("Name")}
                  name="name"
                  value={formik.values.name}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  required
                />
              </div>
              {/* Start Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label={t("Start Date") + " *"}
                      name="startDate"
                      format="MM/DD/YYYY"
                      value={
                        selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate?.toString().trim()
                          ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate)
                          : dayjs(selectedRow?.deliverable?.StartDate)
                      }
                      on
                      readOnly={
                        isLoading || disabled

                      }
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
                {formik.touched.startDate &&
                  formik.errors.startDate && (
                    <span className="text-danger">
                      {formik.errors.startDate}
                    </span>
                  )}
              </div>
              {/* End Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label={t("End Date") + " *"}
                      name="endDate"
                      format="MM/DD/YYYY"
                      value={
                        selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate?.toString().trim()
                          ? dayjs(selectedRow?.deliverable.PortfolioDeliverable[0]?.endDate)
                          : dayjs(selectedRow?.deliverable?.endDate)
                      }
                      readOnly={
                        isLoading || disabled
                      }
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
                {formik.touched.endDate &&
                  formik.errors.endDate && (
                    <span className="text-danger">
                      {formik.errors.endDate}
                    </span>
                  )}
              </div>
              {/* description */}
              {/* {(selectedRow.currentStatus === ProjectDeliverableStatus.REJECTED || 
                selectedRow?.description !== null
                )
              && (
                <div className="col-sm-12 mb-3">
                  <TextField
                    fullWidth
                    className="form-control"
                    id="deliverable-title-input"
                    label={t("Description")}
                    name="description"
                    value={formik.values.description}
                    disabled={action === Action.VIEW || action === Action.APPROVE}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    required
                    rows={2}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <span className="text-danger">{formik.errors.description}</span>
                  )}
                </div>
              )} */}
              {/* Crn Name */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnName !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("CR Name")}
                    name="crnName"
                    value={formik.values.crnName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                    // onKeyDown={handleKeyDownWeight}
                    required
                  />
                  {formik.touched.crnName && formik.errors.crnName && (
                    <span className="text-danger">{formik.errors.crnName}</span>
                  )}
                </>
                {/* : <></>)} */}
              </div>
              {/* CRN Name Attachment */}
              {
                <>
                  <div className="col-sm-12 mb-3">
                    {(action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW
                    && !crnNameLoading && Object.keys(crnNameFiles).length === 0) ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach CR Name Document")}
                            <span style={{ color: 'red' }}>*</span>
                          </span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('CRN Name', e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.crnNameAttachmentId) {
                                formik.setFieldTouched("crnNameAttachmentId", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : ((!crnNameLoading && Object.keys(crnNameFiles).length > 0) && (
                      <h5 className="mb-0">{t("Attached CR Name Document") + ":"}</h5>
                    )
                    )}
                  </div>
                  <div className="mx-3 mb-2">
                    {formik.touched.crnNameAttachmentId && formik.errors.crnNameAttachmentId && (
                      <span className="text-danger">{formik.errors.crnNameAttachmentId}</span>
                    )}
                  </div>
                  <div>
                    {crnNameLoading && <Loader />}
                    {
                      !crnNameLoading && Object.keys(crnNameFiles).length > 0 &&
                      // && crnNameFiles?.length > 0 && crnNameFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={crnNameFiles?.name}>
                            {middleTruncate(crnNameFiles?.name)} 
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(crnNameFiles.storageLink))
                              setFileName(middleTruncate(crnNameFiles?.name))
                            }} />
                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(crnNumberFiles.id)
                            }} />
                            {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW &&(
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(crnNameFiles.id);
                                  setDeletingFileType('CRN Name');
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                    {selectedRow?.deliverableRejectComments?.[0]?.crnNameComment && (
                      <div className="mb-3">
                        <TextField
                          onWheel={(e) => e.target.blur()}
                          fullWidth
                          id="outlined-basic"
                          label={t("CR Name Comment")}
                          name="crnNameComment"
                          multiline
                          rows={3}
                          value={selectedRow?.deliverableRejectComments?.[0]?.crnNameComment}
                          type="text"
                          disabled={true}
                        />
                      </div>
                    )}
                  </div>
                </>
              }
              {/* Crn Number */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnNumber !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("CR Number")}
                    name="crnNumber"
                    value={formik.values.crnNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                    required
                  />
                  {formik.touched.crnNumber && formik.errors.crnNumber && (
                    <span className="text-danger">{formik.errors.crnNumber}</span>
                  )}
                </>
                {/* : <></>)} */}
              </div>
              {/* CRN Number Attachment */}
              {
                <>
                  <div className="col-sm-12 mb-3">
                    {((action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) && !crnNumberLoading && Object.keys(crnNumberFiles).length === 0) ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach CR Number Document")}
                            <span style={{ color: 'red' }}>*</span>
                          </span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('CRN Number', e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.crnNumAttachmentId) {
                                formik.setFieldTouched("crnNumAttachmentId", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : (!crnNumberLoading && Object.keys(crnNumberFiles).length > 0 && (
                      <h5 className="mb-0">{t("Attached CR Number Document") + ":"}</h5>
                    )
                    )}
                  </div>
                  <div className="mx-3 mb-2">
                    {formik.touched.crnNumAttachmentId && formik.errors.crnNumAttachmentId && (
                      <span className="text-danger">{formik.errors.crnNumAttachmentId}</span>
                    )}
                  </div>
                  <div>
                    {crnNumberLoading && <Loader />}
                    {
                      !crnNumberLoading && Object.keys(crnNumberFiles).length > 0 &&
                      // crnNumberFiles?.length > 0 && crnNumberFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between' >
                          {/* key={key}> */}
                          <span className='fw-semibold text-truncate' title={crnNumberFiles?.name}>
                            {middleTruncate(crnNumberFiles?.name)} 
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(crnNumberFiles.storageLink))
                              setFileName(middleTruncate(crnNumberFiles?.name))
                            }} />
                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(crnNumberFiles.id)
                            }} />
                            {(action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) 
                            && (
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(crnNumberFiles.id);
                                  setDeletingFileType('CRN Number');
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                    {selectedRow?.deliverableRejectComments?.[0]?.crnNumberComment && (
                      <div className="mt-2 mb-2">
                        <TextField
                          onWheel={(e) => e.target.blur()}
                          fullWidth
                          id="outlined-basic"
                          label={t("CR Number Comment")}
                          name="crnNumberComment"
                          multiline
                          rows={3}
                          value={selectedRow?.deliverableRejectComments?.[0]?.crnNumberComment}
                          type="text"
                          disabled={true}
                        />
                      </div>
                    )}
                  </div>
                </>
              }
              {/* Iban Number */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnName !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("IBAN Number")}
                    name="iBanNumber"
                    value={formik.values.iBanNumber}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                    required
                  />
                  {formik.touched.iBanNumber && formik.errors.iBanNumber && (
                    <span className="text-danger">{formik.errors.iBanNumber}</span>
                  )}
                </>
                {/* : <></>)} */}
              </div>
              {/* IBAN No Certificate Attachment */}
              {
                <>
                  <div className="col-sm-12 mb-3">
                    {((action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) 
                    && !iBanNumberLoading && Object.keys(iBanNumberFiles).length === 0) ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach IBAN No Certificate")}
                            <span style={{ color: 'red' }}>*</span>
                          </span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('IBAN Certificate', e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.crnNumAttachmentId) {
                                formik.setFieldTouched("crnNumAttachmentId", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : (!iBanNumberLoading && Object.keys(iBanNumberFiles).length > 0 && (
                      <h5 className="mb-0">{t("Attached IBan No Certificates") + ":"}</h5>
                    )
                    )}
                  </div>
                  <div className="mx-3 mb-2">
                    {formik.touched.iBanNumAttachmentId && formik.errors.iBanNumAttachmentId && (
                      <span className="text-danger">{formik.errors.iBanNumAttachmentId}</span>
                    )}
                  </div>
                  <div>
                    {iBanNumberLoading && <Loader />}
                    {
                      !iBanNumberLoading && Object.keys(iBanNumberFiles).length > 0 &&
                      // iBanNumberFiles?.length > 0 && iBanNumberFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={iBanNumberFiles?.name}>
                            {middleTruncate(iBanNumberFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(iBanNumberFiles.storageLink))
                              setFileName(middleTruncate(iBanNumberFiles.name))
                            }} />
                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(iBanNumberFiles.id)
                            }} />
                            {(action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) 
                            && (
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(iBanNumberFiles.id);
                                  setDeletingFileType('IBAN Certificate');
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                    {selectedRow?.deliverableRejectComments?.[0]?.iBanNumberComment && (
                      <div className="mb-2 mt-2">
                        <TextField
                          onWheel={(e) => e.target.blur()}
                          fullWidth
                          id="outlined-basic"
                          label={t("IBAN Number Comment")}
                          name="iBanNumberComment"
                          multiline
                          rows={3}
                          value={selectedRow?.deliverableRejectComments?.[0]?.iBanNumberComment}
                          type="text"
                          disabled={true}
                        />
                      </div>
                    )}
                  </div>
                </>
              }
              {/* Bank Name */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.crnName !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("Bank Name")}
                    name="bankName"
                    value={formik.values.bankName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                    // onKeyDown={handleKeyDownWeight}
                    required
                  />
                  {formik.touched.bankName && formik.errors.bankName && (
                    <span className="text-danger">{formik.errors.bankName}</span>
                  )}
                  {selectedRow?.deliverableRejectComments?.[0]?.bankNameComment && (
                    <div className="mt-3">
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="outlined-basic"
                        label={t("Bank Name Comment")}
                        name="bankNameComment"
                        multiline
                        rows={3}
                        value={selectedRow?.deliverableRejectComments?.[0]?.bankNameComment}
                        type="text"
                        disabled={true}
                      />
                    </div>
                  )}
                </>
                {/* : <></>)} */}
              </div>
              {/* Establishment Contract Attachment */}
              {
                <>
                  <div className="col-sm-12 mb-3">
                    {((action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) 
                    && !establishmentContractLoading && Object.keys(establishmentContractFiles).length === 0) ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach Article of Association")}
                            <span style={{ color: 'red' }}>*</span>
                          </span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('Establishmnent Contract', e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.establishmentContractAttachmentId) {
                                formik.setFieldTouched("establishmentContractAttachmentId", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : (!establishmentContractLoading && Object.keys(establishmentContractFiles).length > 0 && (
                      <h5 className="mb-0">{t("Attached Article of Association") + ":"}</h5>
                    )
                    )}
                  </div>
                  <div className="mx-3 mb-2">
                    {formik.touched.establishmentContractAttachmentId && formik.errors.establishmentContractAttachmentId && (
                      <span className="text-danger">{formik.errors.establishmentContractAttachmentId}</span>
                    )}
                  </div>
                  <div>
                    {establishmentContractLoading && <Loader />}
                    {
                      !establishmentContractLoading && Object.keys(establishmentContractFiles).length > 0 &&
                      // establishmentContractFiles?.length > 0 && establishmentContractFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={establishmentContractFiles?.name}>
                            {middleTruncate(establishmentContractFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(establishmentContractFiles.storageLink))
                              setFileName(middleTruncate(establishmentContractFiles?.name))
                            }} />
                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(establishmentContractFiles.id)
                            }} />
                            {(action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) 
                            && (
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(establishmentContractFiles.id);
                                  setDeletingFileType('Establishmnent Contract');
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                    {selectedRow?.deliverableRejectComments?.[0]?.establishmentContractComment && (
                      <div className="mb-2 mt-2">
                        <TextField
                          onWheel={(e) => e.target.blur()}
                          fullWidth
                          id="outlined-basic"
                          label={t("Article of Association")}
                          name="establishmentContractComment"
                          multiline
                          rows={3}
                          value={selectedRow?.deliverableRejectComments?.[0]?.establishmentContractComment}
                          type="text"
                          disabled={true}
                        // onKeyDown={handleKeyDownWeight}
                        />
                      </div>
                    )}
                  </div>
                </>
              }
              {/* Agreement Document Attachment */}
              {
                <>
                  <div className="col-sm-12 mb-3">
                    {((action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) 
                    && !agreementDocFileLoading && Object.keys(agreementDocFiles).length === 0) ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach MISA Agreement")}</span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('Agreement Document', e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.agreementDocFileId) {
                                formik.setFieldTouched("agreementDocFileId", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : (!agreementDocFileLoading && Object.keys(agreementDocFiles).length > 0 && (
                      <h5 className="mb-0">{t("Attached MISA Agreement") + ":"}</h5>
                    )
                    )}
                  </div>
                  <div className="mx-3 mb-2">
                    {formik.touched.agreementDocFileId && formik.errors.agreementDocFileId && (
                      <span className="text-danger">{formik.errors.agreementDocFileId}</span>
                    )}
                  </div>
                  <div>
                    {agreementDocFileLoading && <Loader />}
                    {
                      !agreementDocFileLoading && Object.keys(agreementDocFiles).length > 0 &&
                      // establishmentContractFiles?.length > 0 && establishmentContractFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate' title={agreementDocFiles?.name}>
                            {middleTruncate(agreementDocFiles?.name)}
                          </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(agreementDocFiles.storageLink))
                              setFileName(middleTruncate(agreementDocFiles?.name))
                            }} />
                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(agreementDocFiles.id)
                            }} />
                            {(action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW) && (
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(agreementDocFiles.id);
                                  setDeletingFileType('Agreement Document');
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                    {selectedRow?.deliverableRejectComments?.[0]?.agreementDocumentComment && (
                      <div className="mb-2 mt-2">
                        <TextField
                          onWheel={(e) => e.target.blur()}
                          fullWidth
                          id="outlined-basic"
                          label={t("MISA Agreement Comment")}
                          name="agreementDocumentComment"
                          multiline
                          rows={3}
                          value={selectedRow?.deliverableRejectComments?.[0]?.agreementDocumentComment}
                          type="text"
                          disabled={true}
                        // onKeyDown={handleKeyDownWeight}
                        />
                      </div>
                    )}
                  </div>
                </>
              }

              {/* Acknowledgement of the RC */}
              {/* {
                <>
                  <div className="col-sm-12 mb-3">
                    {((action !== Action.VIEW && action !== Action.APPROVE) && !rcLFileLoading && Object.keys(rcFiles).length === 0) ? (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach Acknowledgement of the RC Document")}
                            <span style={{ color: 'red' }}>*</span>
                          </span>
                          <input
                            key={trigger}
                            type="file"
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('Acknowledgement of the RC', e.target.files[0])}
                            onBlur={() => {
                              if (!formik.touched?.rcFileId) {
                                formik.setFieldTouched("rcFileId", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: "0",
                              left: 0,
                              background: "red",
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    ) : (!rcLFileLoading && Object.keys(rcFiles).length > 0 && (
                      <h5 className="mb-0">{t("Attach Acknowledgement of the RC Document") + ":"}</h5>
                    )
                    )}
                  </div>
                  <div className="mx-3 mb-2">
                    {formik.touched.rcFileId && formik.errors.rcFileId && (
                      <span className="text-danger">{formik.errors.rcFileId}</span>
                    )}
                  </div>
                  <div>
                    {rcLFileLoading && <Loader />}
                    {
                      !rcLFileLoading && Object.keys(rcFiles).length > 0 &&
                      // establishmentContractFiles?.length > 0 && establishmentContractFiles.map((file, key) => (
                      <>
                        <div className='d-flex mt-1 justify-content-between'>
                          <span className='fw-semibold text-truncate'>{rcFiles?.name} </span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                              setModal(true)
                              setFilePath(getUrl(rcFiles.storageLink))
                              setFileName(rcFiles.name)
                            }} />

                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(rcFiles.id)
                            }} />

                            {(action !== Action.VIEW && action !== Action.APPROVE) && (
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(rcFiles.id);
                                  setDeletingFileType('Acknowledgement of the RC');
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <br />
                      </>
                      // ))
                    }
                    {selectedRow?.deliverableRejectComments?.[0]?.acknowledgementRCComment && (
                      <div className="mb-2 mt-2">
                        <TextField
                          onWheel={(e) => e.target.blur()}
                          fullWidth
                          id="outlined-basic"
                          label={t("Acknowledgement of the RC Comment")}
                          name="acknowledgementRCComment"
                          multiline
                          rows={3}
                          value={selectedRow?.deliverableRejectComments?.[0]?.acknowledgementRCComment}
                          type="text"
                          disabled={true}
                        // onKeyDown={handleKeyDownWeight}
                        />
                      </div>
                    )}
                  </div>
                </>
              } */}
            </div>
          </div>

          {action === Action.SUBMIT && [ProjectDeliverableStatus.ONGOING, ProjectDeliverableStatus.REJECTED, ProjectDeliverableStatus.DELAYED].includes(
            selectedRow.currentStatus
          ) && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={deliverableSubmit}
                  disabled={
                    isLoading ||
                    !formik.isValid ||
                    !formik.values.crnNameAttachmentId ||
                    !formik.values.crnNumAttachmentId ||
                    !formik.values.iBanNumAttachmentId ||
                    !formik.values.establishmentContractAttachmentId
                    // !formik.values.rcFileId
                  }
                  className="btn addNew_ProjectBtn"
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Submit")}
                </Button>
              </div>
            )}

          {action === Action.APPROVE 
          && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={async () => {
                    setButtonLoading(true);
                    await handleStatusChange(
                    moduleIdforApproval,
                    actionType,
                    projectIdForApproval,
                    ApprovalStatuses.APPROVED,
                    rowId
                  )
                  setButtonLoading(false)
                  }
                }
                  className="btn addNew_ProjectBtn"
                >
                  {buttonLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Approve")}
                </Button>
              </div>
            )}

            {action === Action.APPROVE_REJECT_SHOW 
            && 
              (
                <div
                  className="proSubmissionActions"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    gap: "7px",
                    paddingTop: "6px",
                  }}
                >
                    {status ? (
                      status === ProjectDeliverableStatus.APPROVED ? (
                        <Button disabled variant="contained" className="approveBtn" style={{ color: "black", border: "none", textTransform: "none" }}>
                          <DoneIcon className="me-1" />
                          {t("Approved")}
                        </Button>
                      ) : status === ProjectDeliverableStatus.REJECTED ? (
                        <Button disabled variant="contained" color="error" className="rejectBtn" style={{ marginRight: "10px", color: "black", textTransform: "none" }}>
                          <ClearIcon className="me-1" />
                          {t("Rejected")}
                        </Button>
                      ) : (
                        <>
                          <Button
                            disableElevation
                            variant="contained"
                            className="approveBtn"
                            style={{
                              backgroundColor: "#90EE90",
                              color: "black",
                              border: "none",
                              textTransform: "none",
                            }}
                            onClick={async () => {
                              setApprovedButtonLoading(true);
                              await handleStatusChange(
                                moduleIdforApproval,
                                actionType,
                                projectIdForApproval,
                                ApprovalStatuses.APPROVED,
                                rowId
                              );
                              setApprovedButtonLoading(false);
                            }}
                          >
                            {approvedButtonLoading && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-1"
                              />
                            )}
                            <DoneIcon className="me-1" />
                            {t("Approve")}
                          </Button>

                          <Button
                            disableElevation
                            variant="contained"
                            color="error"
                            className="rejectBtn"
                            onClick={async () => {
                              setRejectButtonLoading(true);
                              await fetchDeliverableDetails(
                                moduleIdforApproval,
                                projectIdForApproval,
                                Action.SUBMIT,
                                {
                                  moduleId: moduleIdforApproval,
                                  actionType: "projectDeliverable",
                                  projectId: projectIdForApproval,
                                  approvalId: rowId,
                                }
                              );
                              setRejectButtonLoading(false);
                            }}
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#FFC0CB",
                              color: "black",
                              textTransform: "none",
                            }}
                          >
                            {rejectButtonLoading && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-1"
                              />
                            )}
                            <ClearIcon className="me-1" />
                            {t("Reject")}
                          </Button>
                        </>
                      )
                    ) : null}
     
                </div>
              )
            }
        </form>
      </Drawer >
      {isOpenSweetAlert && (
        <SweetAlert
          title="Are you sure want to delete this document?"
          warning
          showCancel
          confirmButtonText="Yes, delete it!"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => handelDeleteAttachment()}
          onCancel={() => {
            setIsOpenSweetAlert(false)
          }}>
        </SweetAlert>
      )}

      {
        modal && (
          <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
        )
      }
    </>
  );
};

export default withTranslation()(SubmitLegalDocument);
